// extracted by mini-css-extract-plugin
module.exports = {"formInputs":"loginSignUp_formInputs__WDNaz","errorColor":"loginSignUp_errorColor__HqoLG","formBox":"loginSignUp_formBox__oz9yd"};